import React from 'react'

const DoubleChevronRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1.13281 0.5L5.79775 5.26774C6.17619 5.65453 6.17831 6.27218 5.80252 6.66155L1.13281 11.5"
            stroke="currentColor"
            strokeOpacity="0.12"
            strokeLinecap="round"
        />
        <path
            d="M5.65625 0.5L10.3212 5.26774C10.6996 5.65453 10.7017 6.27218 10.326 6.66155L5.65625 11.5"
            stroke="currentColor"
            strokeOpacity="0.12"
            strokeLinecap="round"
        />
    </svg>
)

export default DoubleChevronRightIcon
